export default __webpack_public_path__ + "static/media/ArticleImage.35960334.png";